const development = 'development';

const production = 'production';

const env = process.env.NODE_ENV || development;

const protocol = window.location.protocol || 'http';
const hostName = window.location.origin || 'localhost';
const port = process.env.REACT_APP_API_PORT || 7001;
const port2 = process.env.REACT_APP_API_PORT_2 || 7002;
let fileUrl
console.log({ port })

let config = {
  appName: 'Hyperblox Builder',
  apiUrl: `${hostName}/api/v1/r1/`,
  apiV2Url: `${hostName}/api/v2/r1/`,
  api2V2Url: `${hostName}/api/v2/r2/`,
  fileUrl,
  apiBase: hostName
}

switch (env) {
  case development:
    config = {
      domainPrefix: 'dev',
      ...config,
    };
    break;

  case production:
    config = { domainPrefix: 'prod', ...config };
    break;
  default:
    break;
}

export const getIconPath = () => {
  const pathname = window.location.pathname.split('/');

  if (pathname && pathname[1] === "blueprint") {
    fileUrl = `${hostName}/blueprintAssets/${pathname[3]}_${pathname[2]}/`
  }
  return fileUrl
}

getIconPath();

export default Object.freeze(config);